export const TemplatesPermissions = {
  AddNewTemplate:
  {
    permissionsId: 'a5197343-0a44-4fa3-72e5-08d96894ec62',
    permissionsName: 'Add New Template',
    componentsId: null,
    components: null
  },
  ViewTemplates:
  {
    permissionsId: '3542d0c0-be16-4c64-f9e1-08d9689a2271',
    permissionsName: 'View Templates',
    componentsId: null,
    components: null
  },
  DeleteTemplate:
  {
    permissionsId: '0161b231-6ff3-4cc1-f9e2-08d9689a2271',
    permissionsName: 'Delete Template',
    componentsId: null,
    components: null
  },
  EditTemplate:
  {
    permissionsId: 'ac7ce7e2-bc14-4c40-f9e3-08d9689a2271',
    permissionsName: 'Edit Template',
    componentsId: null,
    components: null
  }

};
